import betting from '@/api/game/game-betting'
import company from '@/api/administrator/company'
import gameSet from '@/api/administrator/game-set'

import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
  ...baseState,
  game_type_id: [1,2],
  date_now: moment().format('DD-MM-YYYY')
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DATE(state, date) {
    state.date_now = date
  },
  SET_GAME_TYPE(state, game_type) {
    state.game_type_id = game_type
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign({
      include: 'dealer,game_bettings.user,game_bettings.game_set.game_setting,game_bettings.details.game_lot',
      page: context.state.pagination.page,
      perPage: context.state.pagination.perPage,
      search: context.state.search,
      date_now: context.state.date_now,
      game_type_id: context.state.game_type_id
    }, attrubutes)
    return betting.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return betting.store(data)
  },
  validate(context, data) {
    return betting.validate(data)
  },
  destroy(context, { id, data }) {
    return betting.destroy(id, data)
  },
  getCompany(context) {
    return company.get({
      params: {
        fields: {
          company_profiles:
            'company_id,company_name_en,company_logo,company_name_kh'
        },
        page: -1
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getGameSet(context, attributes = {}) {
    return gameSet.get({
      params: Object.assign(
        {},
        {
          include: 'game_setting,game_setting.game_lots',
          fields: {
            game_sets:
              'game_set_name,game_set_id,result_date,close_time,game_setting_id,game_type_id'
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  }
}
